import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../assets/loader.json";

const LoadingSpinner = ({ fullscreen = false }) => (
  <div className={`loading-container ${fullscreen ? "is-fullscreen" : ""}`}>
    <div className="lottie-wrapper">
      <Lottie animationData={loaderAnimation} loop={true} />
    </div>
    <p className="loading-text">Loading news...</p>
  </div>
);

export default LoadingSpinner;
